import axios from "axios";

class imageClient {
    async handleSingleSubmit(url) {
        try {
            const response = await axios.post(
                "https://images.kgkdms.com/damImage/pathencryption",
                [{ url }]
            );

            const validationData = response.data[0];
            return {
                pathFile: validationData.filePath || validationData.url,
                message: validationData.message || "",
            }

        } catch (error) {
            console.log(error)
            return { error }
        }
    }
    async folderStructure(folderUrl,queryObj, tokens) {
        try {
            const url = new URL(folderUrl);
            const searchParamsObj = new URLSearchParams(url.search);
            searchParamsObj.set("page", 0);
            searchParamsObj.set("eachPage", 500);

            // Combine existing search parameters with the new query object
            const searchParamsObjData = Object.fromEntries(
                searchParamsObj.entries()
            );
            const paramsObj = { ...searchParamsObjData, ...queryObj };
            const searchParams = new URLSearchParams(paramsObj);
            url.search = searchParams;

            // Make the request using Axios
            const response = await axios.get(url.href, {
                headers: {
                    Authorization: tokens, // Replace with your actual token
                },
            });

            const data = response.data;
            const foldersData = data.filter((item) => item.isFolder);
            const imagesData = data.filter((item) => !item.isFolder);
            return {foldersData, imagesData}
        } catch (error) {
            console.log(error)
            return { error }
        }
    }

}

const imageClientInstance = new imageClient();

export default imageClientInstance;